module.exports = __webpack_public_path__ + "static/media/ic_highlight_off_24px_press.ab322d26.svg";